/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import DeliveryModel from 'cio/models/delivery';
import { IdentifierType } from 'cio/utils/identifiers';

interface MetadataArgs
  extends Pick<
    DeliveryModel,
    | 'id'
    | 'campaign'
    | 'broadcastTrigger'
    | 'newsletter'
    | 'customer'
    | 'transactionalMessage'
    | 'customerId'
    | 'action'
    | 'customerDeleted'
  > {
  originalDeliveryId: string;
  identifierType: IdentifierType;
}

export default class Metadata extends Component<MetadataArgs> {}
